import { render, staticRenderFns } from "./PopoverContentDetail.vue?vue&type=template&id=a36ab6ec&"
import script from "./PopoverContentDetail.vue?vue&type=script&lang=js&"
export * from "./PopoverContentDetail.vue?vue&type=script&lang=js&"
import style0 from "./PopoverContentDetail.vue?vue&type=style&index=0&id=a36ab6ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports